import App from '../client/App';

import {
  AppUpdate,
  Careers,
  Conciairge,
  Filters,
  FilterStandaloneWraper,
  FilterWrapper,
  Gottcha,
  Landing,
  NotFound,
  OurStory,
  Peacekeeper,
  Performance,
  Referral,
  StandWithUkraine,
  Support,
  TheWallOfLove,
  WhyMila,
  WhyMilaLanding,
  AppPage,
  CESLanding,
  AccessibilityPolicy,
  ProductLanding,
  Warranty,
  LandingAir,
  Technology,
} from '../client/pages';

export default [
  {
    ...App,
    routes: [
      {
        ...Landing,
        path: [ '/intl', '/uk' ],
        exact: true,
        meta: {
          title: 'Mila Cares',
          description: 'Mila Cares',
        },
      },
      {
        ...LandingAir,
        path: [ '/', '/us', '/ca' ],
        exact: true,
        meta: {
          title:
            'Mila Air Purifiers | Award-Winning Clean Air for Healthy Homes',
          description: 'Mila is the best smart air purifier for home use. Award-winning design, quieter performance, and powerful clean air for every room.',
        },
      },

      {
        ...Performance,
        path: '/performance',
        exact: true,
        meta: {
          title: 'Best Performing Air Purifier – Smarter, Faster & More Affordable | Mila',
          description: 'Mila delivers powerful performance: faster cleaning, smarter sensors, and better value than pricey brands.',
        },
      },
      // {
      //   ...Performance,
      //   path: '/performance',
      //   exact: true,
      //   meta: {
      //     title: 'Mila Cares | Performance Refresh',
      //   },
      // },
      {
        ...Technology,
        path: '/technology',
        exact: true,
        meta: {
          title: 'Mila Cares | Technology',
        },
      },
      {
        ...Filters,
        path: '/filters',
        exact: true,
        meta: {
          title: 'Custom Air Purifier Filters – HEPA & Carbon Filters for Every Need',
          description: 'Mila’s custom air purifier filters handle pets, VOCs, and particles. HEPA + carbon options for cleaner air tailored to your home.',
        },
      },
      {
        ...FilterWrapper,
        path: '/filters/:type',
        exact: false,
        meta: {},
      },
      {
        ...AppUpdate,
        path: '/lp/update-113',
        exact: true,
        meta: {
          title: 'Mila Cares | App Updates | Update 1.13',
        },
      },
      {
        ...WhyMilaLanding,
        path: '/lp/why-mila',
        exact: true,
        meta: {
          title: 'How Mila Differs from Other Air Purifiers',
          description: 'Learn how Mila outperforms ordinary purifiers—real-time cleaning metrics, intelligent sizing, high CADR, quiet mode, and true carbon filtration.',
        },
      },
      {
        ...Peacekeeper,
        path: '/lp/peacekeeper',
        exact: true,
        meta: {
          title:
            'Air Filter to Keep the Air Relaxed and Drama Free | The Peacekeeper | Mila Cares',
        },
      },
      {
        ...Gottcha,
        path: '/lp/gotcha',
        exact: true,
        meta: {
          title: 'Gotcha! | Happy April Fool’s | Mila Cares',
        },
      },
      {
        ...Warranty,
        path: '/lp/warranty',
        exact: true,
        meta: {
          title: 'Warranty | Mila Cares',
        },
      },
      {
        ...ProductLanding,
        path: '/product/:type',
        exact: true,
        meta: {},
      },
      {
        ...FilterStandaloneWraper,
        path: '/lp/:type',
        exact: true,
        meta: {},
      },
      {
        ...WhyMila,
        path: '/why-mila',
        exact: true,
        meta: {
          title: 'How Mila Differs from Other Air Purifiers',
          description: 'Learn how Mila outperforms ordinary purifiers—real-time cleaning metrics, intelligent sizing, high CADR, quiet mode, and true carbon filtration.',
        },
      },
      {
        ...OurStory,
        path: '/our-story',
        exact: true,
        meta: {
          title: 'Our Story | Mila Air Purifier for Families Who Care',
          description: 'Discover the story behind Mila, the air purifier designed for families. Award-winning clean air, smarter design, and healthier homes for all.',
        },
      },
      {
        ...TheWallOfLove,
        path: '/the-wall-of-love',
        exact: true,
        meta: {
          title: 'Mila Air Purifier Reviews – Real Stories from Happy Customers',
          description: 'Read real Mila air purifier reviews. Discover how families sleep better, breathe easier, and trust Mila for cleaner, fresher home air.',
        },
      },
      {
        ...StandWithUkraine,
        path: '/stand-with-ukraine',
        exact: true,
        meta: {
          title: 'Mila Cares | Stand With Ukraine',
        },
      },
      {
        ...Support,
        path: '/support',
        exact: true,
        meta: {
          title: 'Mila Cares | Support',
        },
      },
      {
        ...Careers,
        path: '/careers',
        exact: true,
        meta: {
          title: 'Careers at Mila – Join an Air Purifier Company Shaping Smarter Clean Air',
          description: 'Discover air purifier company careers at Mila. Join our team, drive innovation, and help create cleaner, healthier air for every home.',
        },
      },
      {
        ...Referral,
        path: '/referral',
        exact: true,
        meta: {
          title: 'Refer a Friend | Give $50, Get a Free Filter',
        },
      },
      {
        ...Conciairge,
        path: '/conciairge',
        exact: true,
        meta: {
          title: 'Mila Cares | Conciairge',
        },
      },
      {
        ...AccessibilityPolicy,
        path: '/accessibility-policy',
        exact: true,
        meta: {
          title: 'Mila Cares | Accessibility Policy',
        },
      },
      {
        ...AppPage,
        path: '/app',
        exact: true,
        meta: {
          title: 'Air Purifier App – Control Your Air Quality with Mila',
          description: 'Experience the Mila air purifier app. Monitor real-time air quality, manage smart modes like Bubble Boy, Sleep, and get end-to-end control in your pocket.',
          trailingSlash: true,
        },
      },
      {
        ...CESLanding,
        path: '/sneakpeek',
        exact: true,
        meta: {
          title: 'Mila Cares | Product Sneak Peek',
        },
      },
      {
        ...NotFound,
      },
    ],
  },
];
